import { 
  CalendarDaysIcon, 
  ClockIcon,
  ScaleIcon,
  UserGroupIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';

export interface EventTypeDefinition {
  id: string;
  label: string;
  icon: any;
  color: string;
}

// Event type definitions with legal-specific types  
export const EVENT_TYPES: EventTypeDefinition[] = [
  { id: 'meeting', label: 'Meetings', icon: UserGroupIcon, color: 'blue' },
  { id: 'deadline', label: 'Deadlines', icon: ClockIcon, color: 'red' },
  { id: 'court-date', label: 'Court Dates', icon: ScaleIcon, color: 'purple' },
  { id: 'consultation', label: 'Consultations', icon: DocumentTextIcon, color: 'green' },
  { id: 'deposition', label: 'Depositions', icon: DocumentTextIcon, color: 'orange' },
  { id: 'hearing', label: 'Hearings', icon: ScaleIcon, color: 'indigo' },
  { id: 'filing-deadline', label: 'Filing Deadlines', icon: ClockIcon, color: 'amber' },
  { id: 'client-meeting', label: 'Client Meetings', icon: UserGroupIcon, color: 'teal' },
  { id: 'internal', label: 'Internal', icon: CalendarDaysIcon, color: 'gray' },
];

export const getEventTypeById = (id: string): EventTypeDefinition | undefined => {
  return EVENT_TYPES.find(type => type.id === id);
};

export const getEventTypeColor = (id: string): string => {
  const eventType = getEventTypeById(id);
  return eventType?.color || 'gray';
}; 